<template>
  <div id="main-wrapper">
    <Navbar></Navbar>
    <Sidebar style="z-index: 100"></Sidebar>
    <section
      style="
        display: flex;
        padding-top: 100px;
        padding-left: 200px;
        padding-bottom: 25px;
      "
    >
      <div style="width: 100%">
        <transition
          mode="out-in"
          enter-active-class="fadeIn"
          leave-active-class="fadeOut"
          appear
        >
          <router-view class="animated" style="width: 100%"></router-view>
        </transition>
      </div>
    </section>
    <footer
      class="col-12"
      style="
        bottom: 0;
        position: absolute;
        padding: 10px;
        background-color: white;
        z-index: 98;
      "
    >
      <div
        style="
          display: flex;
          justify-content: space-between;
          margin-right: 20px;
          padding-left: 215px;
        "
      >
        <div>YurBe © {{ year }}</div>
        <div>Version {{ versionNumber }}</div>
      </div>
    </footer>
  </div>
</template>
<script type="text/babel">
import { mapState } from "vuex";
import Navbar from "../../components/Navbar.vue";
import Sidebar from "../../components/Sidebar.vue";
export default {
  data() {
    return {
      image: process.env.VUE_APP_BASE_URL + "/img/laravel-vue.svg",
    };
  },
  components: { Navbar, Sidebar },
  methods: {
    onToggleCollapse(collapsed) {
    },
    onItemClick(event, item) {
      if (item.title == "Logout") {
        this.$store.dispatch("logoutUser");
      }
    },
  },
  watch: {},
  computed: {
    year() {
      return new Date().getFullYear();
    },
    ...mapState({
      sideBarMinimized: (state) => state.appStore.sideBarMinimized,
      versionNumber: (state) => state.appStore.versionNumber,
    }),
  },
};
</script>
<style lang="scss">
$scaleSize: 0.95;
@keyframes zoomIn95 {
  from {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
  to {
    opacity: 1;
  }
}
.main-panel .zoomIn {
  animation-name: zoomIn95;
}
@keyframes zoomOut95 {
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
    transform: scale3d($scaleSize, $scaleSize, $scaleSize);
  }
}
.main-panel .zoomOut {
  animation-name: zoomOut95;
}
</style>

<style>
.md-theme-default a:not(.md-button) {
  color: white !important;
}
.v-sidebar-menu .vsm--header {
  font-size: 32px;
  text-align: center;
  padding: 15px;
  color: white !important;
}
/* Hide scrollbar for Chrome, Safari and Opera */
.md-theme-default::-webkit-scrollbar {
  display: none;
  overflow: scroll;
}
.md-theme-default {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
  overflow: scroll;
}
</style>


// WEBPACK FOOTER //
// resources/js/pages/admin/main.vue